"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCreateStream = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var common_streams_utils_1 = require("@moralisweb3/common-streams-utils");
var IncorrectNetworkError_1 = require("../utils/IncorrectNetworkError");
var StreamNetwork_1 = require("../utils/StreamNetwork");
var makeCreateAptosStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.createStreamAptosOperation, baseUrl, core).fetch(options);
};
var makeCreateEvmStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.createStreamEvmOperation, baseUrl, core).fetch(options);
};
var makeCreateStream = function (core, baseUrl) {
    return (function (createStreamOptions) {
        switch (createStreamOptions.networkType) {
            case StreamNetwork_1.StreamNetwork.APTOS:
                return makeCreateAptosStream(core, baseUrl, createStreamOptions);
            case StreamNetwork_1.StreamNetwork.EVM:
                return makeCreateEvmStream(core, baseUrl, createStreamOptions);
            default:
                if (createStreamOptions.networkType === undefined) {
                    return makeCreateEvmStream(core, baseUrl, createStreamOptions);
                }
                throw new IncorrectNetworkError_1.IncorrectNetworkError(createStreamOptions.networkType);
        }
    });
};
exports.makeCreateStream = makeCreateStream;
//# sourceMappingURL=create.js.map